// select 下拉加载更多数据指令
import more from './more.js'
import Vue from 'vue'

const install = function(Vue) {
  Vue.directive('more', more)
}

if (window.Vue) {
  window.more = more
  Vue.use(install); // eslint-disable-line
}

more.install = install
export default more

